<template>
  <v-chart
    class="lifecycle-chart"
    :options="chartOptions"
    autoresize
    @click="handleChartClick"
  />
</template>

<script>
import {
  DataZoomComponent,
  GridComponent,
  TooltipComponent,
} from "echarts/components";
import ECharts from "vue-echarts";
import { LIFECYCLE_ICONS } from "../../utils/constants";
import { LineChart } from "echarts/charts";
import { formatToPercents } from "../../utils/helper";
import { use } from "echarts/core";
use([GridComponent, LineChart, TooltipComponent, DataZoomComponent]);
export default {
  name: "Spatial-versions-chart",
  components: {
    "v-chart": ECharts,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      chartOptions: {
        grid: [
          {
            left: 50,
            width: "absolute",
            right: 25,
            show: true,
            borderWidth: 0,
            height: "auto",
            bottom: 25,
          },
        ],
        dataZoom: [
          {
            type: "inside",
          },
        ],
        tooltip: {
          trigger: "item",
          axisPointer: "cross",
          formatter: (item) => {
            return `
            <div class="chart-tooltip-inner">
              <p class="body-bold">${item.data.name}</p>
              <div class="chart-tooltip-item">
          <span class="name">
          ${this.$i18n.t("portfolioManager.significantMeasures.volatility")}:
          </span>
          <span class="value">
          ${this.formatToPercents(item.value[0], true)}
          </span>
        </div>
        <div class="chart-tooltip-item">
          <span class="name">
          ${this.$i18n.t(
            "portfolioManager.significantMeasures.expectedReturn"
          )}:
          </span>
          <span class="value">
          ${this.formatToPercents(item.value[1], true)}
          </span>
        </div>
        </div>
            `;
          },
        },
        xAxis: {
          type: "value",
          min: "dataMin",
          max: "dataMax",
          axisLabel: {
            formatter: (val) => Math.round(val * 10000) / 100 + " %",
          },
        },
        yAxis: {
          type: "value",
          min: "dataMin",
          max: "dataMax",
          axisLabel: {
            formatter: (val) => Math.round(val * 10000) / 100 + " %",
          },
        },
        series: [
          {
            type: "line",
            data: [],
            symbolSize: 12,
            symbol: (val, params) =>
              params.dataIndex === 0
                ? LIFECYCLE_ICONS.initialPortfolio
                : params.data.rebalance
                ? LIFECYCLE_ICONS.rebalancedPortfolio
                : LIFECYCLE_ICONS.weeklyChange,
          },
        ],
      },
    };
  },
  methods: {
    formatToPercents,
    populateData() {
      if (this.data && this.data.length) {
        this.chartOptions.series[0].data = this.data.map((version) => ({
          ...version,
          value: [
            version.custom_portfolio_output.volatility
              ? version.custom_portfolio_output.volatility
              : 0,
            version.custom_portfolio_output.expected_return
              ? version.custom_portfolio_output.expected_return
              : 0,
          ],
        }));
      }
    },
    handleChartClick(item) {
      this.$emit("chartClick", item.data.history_id);
    },
  },
  mounted() {
    this.populateData();
  },
  watch: {
    data() {
      this.populateData();
    },
  },
};
</script>

<style>
</style>